const initialState = {
    siteDetails: {},
    locationList: [],
    totalLocationsCount: 0,
};

const locationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOCATION_LIST': {
            return {
                ...state,
                siteDetails: action.payload?.siteDetails,
                locationList: action.payload.locations,
                totalLocationsCount: action.payload.totalCount,
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default locationReducer;